import { Statement } from './statement.model';

export const mapNewStatementToDeprecated = (
  statement: Statement[]
): Statement[] =>
  statement.map((item) => ({
    id: item.id,
    content: item.content,
    clientDataIds: [],
    accepted: item.accepted,
    name: item.name
  }));
